module.exports = __webpack_public_path__ + "28632209c1c567c1aea57d66262ff751.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/thankYouImage/background-blue.svg
// module id = ./src/helpers/images/thankYouImage/background-blue.svg
// module chunks = 5